import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { MatterAccountingSelectors } from '@state/matter/accounting/accounting.selectors';
import {
	LeapCostRecoveryItem,
	LeapFeeTaskCodeItem,
} from '@state/matter/accounting/accounting.models';
import { Observable } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterStatementofAccountSelectors } from '@state/matter/statementOfAccounts/statementOfAccounts.selectors';
import { StatementOfAccountTotals } from '@services/financialTotals/financial-totals.service';

@UntilDestroy()
@Component({
	selector: 'app-leap-accounting',
	templateUrl: './leap.accounting.component.html',
	standalone: false,
})
export class LeapAccountingComponent {
	@Select(MatterAccountingSelectors.getLeapNonZeroNonHstItems)
	leapNonHstItems$: Observable<LeapCostRecoveryItem[]>;
	@Select(MatterAccountingSelectors.getLeapNonZeroHstItems)
	leapHstItems$: Observable<LeapCostRecoveryItem[]>;
	@Select(MatterAccountingSelectors.getLeapNonZeroConvenyancingFeeItems)
	leapConvenyancingFeeItems$: Observable<LeapFeeTaskCodeItem[]>;
	@Select(MatterStatementofAccountSelectors.statementOfAccountsTotals)
	totals$: Observable<StatementOfAccountTotals>;

	@Select(SelectedMatter.matterHST) hst$: Observable<number>;
}
